import { ref, watch } from "vue";
import { defineStore } from "pinia";

const STORAGE_KEY = "theme";

const applyTheme = (theme) => {
  document.documentElement.setAttribute("data-theme", theme);
};

// Se instancia una vez en main.js (antes del mount) para evitar el parpadeo
// del tema por defecto al cargar la página.
export const useThemeStore = defineStore("theme", () => {
  const initial = localStorage.getItem(STORAGE_KEY) || "light";

  const theme = ref(initial);
  applyTheme(theme.value);

  const toggle = () => {
    theme.value = theme.value === "dark" ? "light" : "dark";
  };

  watch(theme, (value) => {
    localStorage.setItem(STORAGE_KEY, value);
    applyTheme(value);
  });

  return { theme, toggle };
});
